"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let timer;
function debounce(func, timeout = 300) {
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
exports.default = debounce;
//# sourceMappingURL=helpers.js.map